/*
Place this widget just before the closing tag of the .Article__Main element
*/

import Widget from "./base.js";
import { getCookie } from "tpm-utils";
import getProfile from "tpm-lib/profile";

export class MeteredBumperFall25Widget extends Widget {
	componentWillMount() {
		//if the paywall postmeta is set, never render this component
		if (window.has_paywall) return;

		//look up the profile, if membership_was is set dont show this
		const profileData = this.getProfileData();
		const self = this;

		// if the ComeBack cookie is set we know the comeback modal wont show
		// if it's NOT set we need to check the profile.membership_was
		if (!getCookie("ComeBack")) {
			if (typeof profileData.then === "function") {
				// promise
				profileData.then((resp) => {
					if (resp.membership_was) self.setState({ hideComponent: true });
				});
			} else {
				//not a promise
				if (resp.membership_was) self.setState({ hideComponent: true });
			}
		}
		let views = getCookie("tpm_article_views");
		if (views === null) views = 0;
		else views = parseInt(views);
		//we DO want to count the first and current article view(s) but the pvt might not have got to it yet
		//(race condition). If didtrack is falsy increment the views to account for that
		if (!window.tpm_pvt || !window.tpm_pvt.didtrack) {
			views = views + 1;
		}

		this.state.views = views;

		this.toggleShrink = this.toggleShrink.bind(this);

		document
			.querySelector(".js_site-footer")
			.setAttribute("style", "padding-bottom: 100px");
	}

	componentDidMount() {
		window.mbw = this;
		window.addEventListener("scroll", this.scrollWatcher);
		document
			.querySelector("body")
			.setAttribute("style", "padding-bottom: 80px");
	}

	getProfileData() {
		if (window.tpm_profile) return window.tpm_profile;
		return getProfile();
	}

	scrollWatcher() {
		if (window.mbw.state.hideComponent) return;

		let el = document.querySelector(".js_article-content");
		if (mbw.props.fp) el = document.querySelector(".front-page");

		if (window.scrollY > el.getBoundingClientRect().top) {
			mbw.slideUp();
			window.removeEventListener("scroll", this.scrollWatcher);
		}
	}

	slideUp() {
		document
			.querySelector(".MeteredBumperFall25Widget")
			.classList.add("--slide-up");
	}

	toggleShrink(e) {
		e.preventDefault();
		e.stopPropagation();
		this.setState({ shrunk: !this.state.shrunk });
	}

	get countText() {
		return `You've read ${this.state.views} article${
			this.state.views > 1 ? "s" : ""
		} this month`;
	}

	get secondLevelDomain() {
		return document.location.hostname.split(".")[1];
	}

	href() {
		const source = "on_site";
		const campaign = "memberships_fall24";
		let medium = "bumper_article";
		if (this.props.fp) medium = "bumper_fp";
		const promo = this.state.views > 9 ? "&promo=tpm25" : "";

		return `${document.location.origin}/memberships?utm_source=${source}&utm_medium=${medium}&utm_campaign=${campaign}${promo}`;
	}

	get hrefDirect() {
		const promo = "&promo=tpm25";
		return `https://accounts.talkingpointsmemo.com/membership?plan=prime_year${promo}`;
	}

	list() {
		return (
			<ul className="MeteredBumperFall25__List">
				<li>Reader-funded</li>
				<li className="circle" aria-hidden="true"></li>
				<li>Unionized</li>
				<li className="circle" aria-hidden="true"></li>
				<li>Mission-driven</li>
			</ul>
		);
	}

	buttons() {
		return (
			<div className="MeteredBumperFall25__Buttons">
				<a
					href={`${document.location.origin}/about`}
					className="Button --white"
				>
					Read our mission
				</a>

				<a href={this.href()} className="Button --red">
					Become a member
				</a>
			</div>
		);
	}

	substance() {
		return (
			<div>
				<img
					src={`https://${document.location.hostname}/wp-content/themes/tpm25/assets/images/site-footer/25years-badge-rotated-crop.svg`}
					aria-hidden="true"
					className="MeteredBumperFall25__Logo"
				/>
				<p className="big">TPM’S 25th Anniversary Sale!</p>

				<p>
					To celebrate 25 years publishing thanks to our members, we’re taking
					<b> $25&nbsp;dollars&nbsp;off&nbsp;the&nbsp;annual&nbsp;price</b> of
					any TPM membership
				</p>

				<div className="MeteredBumperFall25__Buttons --margin">
					<a href={this.hrefDirect} className="Button --red">
						$25 Off An Annual TPM Membership
					</a>
				</div>

				<p className="small">
					Help us keep building a better kind of media company
				</p>
			</div>
		);
	}

	renderContent() {
		if (this.state.hideComponent) return;
		console.log(this.props);

		if (this.state.shrunk || document.body.getBoundingClientRect().width < 360)
			return (
				<div className={`MeteredBumperFall25 ${this.props.fp ? "--fp" : ""} `}>
					<div
						className={`MeteredBumperFall25__Inner ${
							this.props.thick ? "--thick" : ""
						}`}
					>
						<div className="MeteredBumperFall25__Top --shrunk">
							<div className="MeteredBumperFall25__TopRight">
								<img
									src={`https://${document.location.hostname}/wp-content/themes/tpm25/assets/images/site-footer/25years-badge-rotated-crop.svg`}
									aria-hidden="true"
									className="MeteredBumperFall25__Logo --shrunk"
								/>
								<div className="MeteredBumperFall25__Body --shrunk">
									<p className="big">TPM’S 25th Anniversary Sale!</p>

									<p className="small">
										Help us keep building a better kind of media company
									</p>
								</div>
								<div className="MeteredBumperFall25__Buttons">
									<a href={this.hrefDirect} className="Button --red">
										$25 Off An Annual TPM Membership
									</a>
								</div>
								<div
									className="MeteredBumperFall25__Shrink --shrunk"
									onClick={this.toggleShrink}
								>
									<i
										class={`fal ${
											this.state.shrunk ? "fa-angle-up" : "fa-angle-down"
										}`}
									></i>
								</div>
							</div>
						</div>
					</div>
				</div>
			);

		return (
			<div className={` MeteredBumperFall25 ${this.props.fp ? "--fp" : ""}`}>
				<div
					className={`MeteredBumperFall25__Inner ${
						this.props.thick ? "--thick" : ""
					}`}
				>
					<div className="MeteredBumperFall25__Top">
						<div
							className="MeteredBumperFall25__Shrink"
							onClick={this.toggleShrink}
						>
							<i
								class={`fal ${
									this.state.shrunk ? "fa-angle-up" : "fa-angle-down"
								}`}
							></i>
						</div>
					</div>
					<div className="MeteredBumperFall25__Body">{this.substance()}</div>
				</div>
				<div className="MeteredBumperFall25__SideSpacer"></div>
			</div>
		);
	}
}
